/* eslint-disable max-len */
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { NotificationState } from './notification.state';

export const selectAppLayoutState = createFeatureSelector<NotificationState>('notification');

export const notificationStatus = createSelector(selectAppLayoutState, (state: NotificationState) => state?.open);

export const hasComponentInjected = createSelector(selectAppLayoutState, (state: NotificationState) => state?.hasCmpInjected);
